<template>
  <div class="listPage">
    <div class="buttonContainer">
      <div class="addDiv">
        <el-button
          class="addBtn"
          @click="showDialog()"
          v-if="null !== addPermission"
          >{{ addPermission.name }}</el-button>
      </div>
      <div id="queryDiv">
        <el-form :model="queryForm" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="queryForm.name"
              placeholder="搜索权限名称"
              @keyup.enter.native="query()"
            >
              <!-- <i class="el-icon-search" slot="suffix" @click="query()"> </i
            > -->
            <div slot="suffix" class="searchClass" @click="query()">搜索</div>
          </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="mainTableContainer">
      <el-table
        class="table"
        :data="tableData"
        :height="tableHeight"
        style="width: 100%"
        ref="commonTable"
        row-key="id"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column
          prop="name"
          label="权限名称"
          min-width="80"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="englishName"
          label="英文名称"
          min-width="30"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column label="权限类型" align="center" min-width="30">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 0">菜单</span>
            <span v-if="scope.row.type == 1">按钮</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="path"
          label="权限路径"
          min-width="50"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="icon"
          label="图标名称"
          min-width="50"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="type"
          label="禁用/启用"
          min-width="40"
          align="center"
        >
          <!-- 禁用 可用-->
          <template slot-scope="scope">
            <el-switch
              active-color="#409EFF"
              inactive-color="#409EFF"
              v-model="scope.row.status"
              :active-value="0"
              :inactive-value="1"
              disabled
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          min-width="100"
          align="center"
          v-if="buttonList.length !== 0"
        >
          <template slot-scope="scope">
            <div class="buttonCol">
              <div v-for="(button, index) in buttonList" :key="index">
                <el-button
                  v-if="button.path === 'permission-edit'"
                  @click="edit(scope.row.id)"
                  icon="el-icon-operte-view"
                  style="
                    font-size: 14px;
                    font-family: AlibabaPuHuiTiR;
                    font-weight: 400;
                    color: #ffffff;
                    background: #0083fd;
                    border-radius: 6px;
                    margin-right: 10px;
                  "
                  class="editBtn"
                  >{{ button.name }}</el-button
                >
                <el-button
                  v-else-if="
                    scope.row.status === 1 && button.path === 'permission-open'
                  "
                  @click="updateStatus(scope.row)"
                  icon="el-icon-operte-view"
                  style="
                    font-size: 14px;
                    font-family: AlibabaPuHuiTiR;
                    font-weight: 400;
                    color: #ffffff;
                    background: #2ac692;
                    border-radius: 6px;
                    margin-right: 10px;
                  "
                  class="openBtn"
                  >{{ button.name }}</el-button
                >
                <el-button
                  v-else-if="
                    scope.row.status === 0 && button.path === 'permission-close'
                  "
                  @click="updateStatus(scope.row)"
                  icon="el-icon-operte-view"
                  style="
                    font-size: 14px;
                    font-family: AlibabaPuHuiTiR;
                    font-weight: 400;
                    color: #ffffff;
                    background: #df291e;
                    border-radius: 6px;
                    margin-right: 10px;
                  "
                  class="closeBtn"
                  >{{ button.name }}</el-button
                >
                <el-button
                  v-else-if="button.path === 'permission-del'"
                  @click="del(scope.row.id)"
                  icon="el-icon-operte-view"
                  style="
                    font-size: 14px;
                    font-family: AlibabaPuHuiTiR;
                    font-weight: 400;
                    color: #ffffff;
                    background: #c1c1c1;
                    border-radius: 6px;
                    margin-right: 10px;
                  "
                  class="delBtn"
                  >{{ button.name }}</el-button
                >
                <el-button
                  v-else-if="
                    scope.row.type === 0 && button.path === 'permission-add-son'
                  "
                  @click="addChild(scope.row)"
                  icon="el-icon-operte-view"
                  style="
                    font-size: 14px;
                    font-family: AlibabaPuHuiTiR;
                    font-weight: 400;
                    color: #ffffff;
                    background: #c1c1c1;
                    border-radius: 6px;
                  "
                  class="editBtn"
                  >{{ button.name }}</el-button
                >
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="43%"
      class="commonScrollDialog permissionPage"
    >
      <div class="scrollContainer">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          @submit.native.prevent
          label-width="100px"
        >
          <div class="rowClass">
            <el-form-item label="权限名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请填写权限名称(20字内)"
                maxlength="20"
                clearable
                class="inputClass"
                @keyup.enter.native="submit('form')"
              ></el-input>
            </el-form-item>
            <div class="right">
              <el-form-item label="英文名称">
                <el-input
                  v-model="form.englishName"
                  placeholder="请填写英文名称(40字内)"
                  maxlength="40"
                  clearable
                  class="inputClass"
                  @keyup.enter.native="submit('form')"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="rowClass">
            <el-form-item label="权限类型" prop="type">
              <el-select
                v-model="form.type"
                placeholder="请选择权限类型"
                class="inputClass"
                popper-class="adminHomeSelect"
                clearable
              >
                <el-option label="菜单" value="0"></el-option>
                <el-option label="按钮" value="1"></el-option>
              </el-select>
            </el-form-item>
            <div class="right">
              <el-form-item label="权限路径" prop="path">
                <el-input
                  v-model="form.path"
                  :disabled="title === '编辑权限'"
                  placeholder="请填写权限路径(100字内)"
                  maxlength="100"
                  clearable
                  class="inputClass"
                  @keyup.enter.native="submit('form')"
                ></el-input>
              </el-form-item>
            </div>
          </div>

          <div class="rowClass">
            <el-form-item label="上级权限">
              <el-select
                :v-model="form.pid"
                :value="valueTitle"
                ref="selectblur"
                popper-class="adminHomeSelect adminHomeTreeSelect"
                @clear="clearHandle"
                placeholder="请选择上级权限"
                :disabled="treeDisabled"
              >
                <el-option :value="valueTitle" :label="valueTitle">
                  <el-tree
                    id="tree-option"
                    ref="selectTree"
                    :data="dataOfTree"
                    :props="props"
                    :node-key="props.value"
                    :default-expanded-keys="defaultExpandedKey"
                    @node-click="handleNodeClick"
                  ></el-tree>
                </el-option>
              </el-select>
            </el-form-item>
            <div class="right">
              <el-form-item label="权限状态" prop="status">
                <el-select
                  v-model="form.status"
                  placeholder="请选择权限状态"
                  clearable
                  class="inputClass"
                  popper-class="adminHomeSelect"
                >
                  <el-option label="启用" value="0"></el-option>
                  <el-option label="禁用" value="1"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>

          <div class="rowClass">
            <el-form-item label="图标名称">
              <el-input
                v-model="form.icon"
                placeholder="请填写图标名称(40字内)"
                maxlength="40"
                clearable
                @keyup.enter.native="submit('form')"
              ></el-input>
            </el-form-item>
            <div class="right">
              <el-form-item label="序号" class="number-adjust-item" prop="seq">
                <div style="width: 100%; display: block;">
                  <el-button
                    icon="el-icon-minus"
                    @click="reduce()"
                    :disabled="reduceDisable"
                  ></el-button>
                  <el-input
                    @keyup.enter.native="submit('form')"
                    v-model="form.seq"
                    @input="seqInput"
                    placeholder="请输入序号(数字)"
                    maxlength="3"
                  ></el-input>
                  <el-button
                    icon="el-icon-plus"
                    @click="add()"
                    :disabled="addDisable"
                  ></el-button>
                </div>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="formItemBtnRow">
            <el-button
              type="primary"
              @click="submit('form')"
              class="confirmBtn"
              :loading="loading"
              >确 定</el-button
            ><el-button @click="dialogVisible = false" class="cancelBtn"
              >取 消</el-button
            >
          </div>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "permission",
  props: ["menuId"],
  data() {
    return {
      loading: false,
      dialogVisible: false,
      addPermission: null,
      buttonList: [],
      title: "添加权限",
      tableData: [],
      queryForm: {
        name: "",
        path: "",
        type: "",
        status: "",
        removed: 0,
      },
      addDisable: false,
      reduceDisable: false,
      form: {
        id: "",
        name: "",
        englishName: "",
        pid: "",
        path: "",
        type: "",
        status: "",
        icon: "",
        seq: 1,
      },
      rules: {
        name: [
          {
            required: true,
            message: "请填写权限名称~",
            maxLength: 20,
            trigger: "blur",
          },
        ],
        path: [
          {
            required: true,
            message: "请填写权限路径~",
            maxLength: 100,
            trigger: "blur",
          },
        ],
        type: [
          { required: true, message: "请选择权限类型~", trigger: "change" },
        ],
        status: [
          { required: true, message: "请选择权限状态~", trigger: "change" },
        ],
        seq: [{ required: true, message: "请填写序号~", trigger: "blur" }],
      },
      /* 配置项 */
      props: {
        value: "id", // ID字段名
        label: "name", // 显示名称
        children: "children", // 子级字段名
      },
      /* 选项列表数据(树形结构的对象数组) */
      dataOfTree: [{}],
      //属性选择器 start
      valueId: this.value, // 初始值
      valueTitle: "",
      defaultExpandedKey: [],
      treeDisabled: false,
      //属性选择器 end
      tableHeight: 500, // 表格高度
    };
  },
  methods: {
    seqInput() {
      let seq = this.form.seq;
      let r = /^[0-9]*$/;
      if (!r.test(seq)) {
        this.form.seq = 1;
      } else {
        seq = Number(seq);
        if (seq > 127) {
          this.form.seq = 127;
        } else if (seq <= 0) {
          this.form.seq = 1;
        } else {
          this.form.seq = seq;
        }
      }
      if (this.form.seq === 127) {
        this.addDisable = true;
        this.reduceDisable = false;
      } else if (this.form.seq === 1) {
        this.addDisable = false;
        this.reduceDisable = true;
      } else {
        this.addDisable = false;
        this.reduceDisable = false;
      }
    },
    add() {
      if (this.form.seq === 126) {
        this.addDisable = true;
      }
      this.reduceDisable = false;
      this.form.seq += 1;
    },
    reduce() {
      if (this.form.seq === 2) {
        this.reduceDisable = true;
      }
      this.addDisable = false;
      this.form.seq -= 1;
    },
    callOnTabSelect() {
      this.$nextTick(function () {
        this.$refs.commonTable.doLayout();
      });
    },
    getTableHeight() {
      let tableH = 260; // 除表格外其他区域高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 300) {
        this.tableHeight = 300;
      } else {
        this.tableHeight = tableHeightDetil;
      }
    },
    //跳出弹框
    showDialog() {
      this.dialogVisible = true;
      this.title = "添加权限";
      this.form = {
        seq: 1,
        status: "0",
      };
      this.addDisable = false;
      this.reduceDisable = true;
      this.clearHandle();
      this.getPermissionTree();
      this.treeDisabled = false;
    },
    //权限树查询
    getPermissionTree() {
      this.initHandle();
      this.query("getPermissionTree");
    },
    // 初始化值
    initHandle() {
      if (this.valueId) {
        try {
          this.valueTitle = this.$refs.selectTree.getNode(this.valueId).data[
            this.props.label
          ]; // 初始化显示
        } catch (error) {
          this.valueTitle = this.props.label; // 初始化显示
        }
        this.$refs.selectTree.setCurrentKey(this.valueId); // 设置默认选中
        this.defaultExpandedKey = [this.valueId]; // 设置默认展开
      }
      this.$nextTick(() => {
        let scrollWrap = document.querySelectorAll(
          ".el-scrollbar .el-select-dropdown__wrap"
        )[0];
        let scrollBar = document.querySelectorAll(
          ".el-scrollbar .el-scrollbar__bar"
        );
        scrollWrap.style.cssText =
          "margin: 0px; max-height: none; overflow: hidden;";
        scrollBar.forEach((ele) => (ele.style.width = 0));
      });
    },
    // 切换选项
    handleNodeClick(node) {
      this.$refs.selectblur.blur(); //让下拉框失去焦点事件
      this.valueTitle = node[this.props.label];
      this.valueId = node[this.props.value];
      this.$emit("getValue", this.valueId);
      this.defaultExpandedKey = [];
    },
    // 清除选中
    clearHandle() {
      this.valueTitle = "";
      this.valueId = null;
      this.defaultExpandedKey = [];
      this.clearSelected();
      this.$emit("getValue", null);
    },
    /* 清空选中样式 */
    clearSelected() {
      let allNode = document.querySelectorAll("#tree-option .el-tree-node");
      allNode.forEach((element) => element.classList.remove("is-current"));
    },
    // 提交表单
    submit(formName) {
      try {
        this.loading = true;
        // 进行验证表单内容是否填写正确
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.form.pid = this.valueId;
            if (this.form.id) {
              //编辑
              this.update(this.form);
            } else {
              //新增
              this.save(this.form);
            }
          } else {
            return false;
          }
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    // 新增
    save(form) {
      this.postJsonRequest("/user-server/api/u-permission/save", form).then(
        (res) => {
          let oData = res.data;
          let _this = this;
          if (oData.code === 0) {
            _this.dialogVisible = false; //关闭弹框
            _this.query();
            this.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (oData.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        }
      );
    },
    // 查询
    query(queryType) {
      try {
        this.loading = true;
        let params = {};
        if (queryType === "getPermissionTree") {
          params = {
            type: 0,
            removed: 0
          };
        } else {
          params = {
            ...this.queryForm,
            id: "",
            status: "",
          };
        }
        this.postJsonRequest(
          "/user-server/api/u-permission/query",
          params
        ).then((res) => {
          let oData = res.data;
          if (oData.code == 0) {
            let data = oData.data;
            if (queryType === "getPermissionTree") {
              this.dataOfTree = data;
            } else {
              this.tableData = data;
            }
          } else if (oData.code != 401) {
            // let tips = "<i class='el-icon-warn-tip'></i>啊哦,信息获取失败~";
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    //编辑
    edit(id) {
      this.dialogVisible = true;
      this.treeDisabled = false;
      this.title = "编辑权限";
      this.getPermissionTree();
      this.getRequest("/user-server/api/u-permission/detail?id=" + id).then(
        (res) => {
          let oData = res.data;
          if (oData.code == 0) {
            let data = oData.data;
            this.form = data;
            this.form.type = String(this.form.type);
            this.form.status = String(this.form.status);
            this.valueId = data.pid;
            this.valueTitle = data.pname;
            let seq = this.form.seq;
            if (seq) {
              if (Number(seq) === 127) {
                this.addDisable = true;
                this.reduceDisable = false;
              } else if (Number(seq) === 1) {
                this.addDisable = false;
                this.reduceDisable = true;
              }
            }
          } else if (oData.code != 401) {
            // let tips = "<i class='el-icon-warn-tip'></i>啊哦,信息获取失败~";
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        }
      );
    },
    // 编辑
    update(form) {
      this.putJsonRequest("/user-server/api/u-permission/update", form).then(
        (res) => {
          let oData = res.data;
          let _this = this;
          if (oData.code === 0) {
            _this.dialogVisible = false; //关闭弹框
            _this.query();
            this.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (oData.code != 401) {
            let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        }
      );
    },
    updateStatus(row) {
      let userId = row.id;
      let status = row.status;
      let str = "";
      let newStatus = 1 - status;
      if (status === 0) {
        str = "此操作将禁用该权限, 是否继续?";
      } else {
        str = "此操作将启用该权限, 是否继续?";
      }
      let tips = "<i class='el-icon-warn-tip'></i>" + str;
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirm-style",
        cancelButtonClass: "cancel-style",
      })
        .then(() => {
          this.putJsonRequest(
            "/user-server/api/u-permission/updateStatus?id=" +
              userId +
              "&status=" +
              newStatus
          ).then((res) => {
            let oData = res.data;
            if (oData.code == 0) {
              this.query();
              this.$message({
                message: "提交成功",
                duration: 1000,
                customClass: "message-s",
                iconClass: "el-icon-ok-tip",
                offset: 470,
                onClose: function () {},
              });
            } else if (oData.code != 401) {
              let tips = "<i class='el-icon-warn-tip'></i>" + oData.data;
              this.$confirm(tips, "提示", {
                confirmButtonText: "好的",
                customClass: "customClass-style",
                iconClass: "",
                dangerouslyUseHTMLString: true,
                confirmButtonClass: "confirm-style",
                showCancelButton: false,
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 删除
    del(id) {
      let tips =
        "<i class='el-icon-warn-tip'></i>将永久删除该条记录, 是否继续?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirm-style",
        cancelButtonClass: "cancel-style",
      })
        .then(() => {
          this.deleteRequest(
            "/user-server/api/u-permission/delete?id=" + id
          ).then((res) => {
            let oData = res.data;
            if (oData.code == 0) {
              this.query();
              this.$message({
                message: "删除成功",
                duration: 1000,
                customClass: "message-s",
                iconClass: "el-icon-ok-tip",
                offset: 470,
                onClose: function () {},
              });
            } else if (oData.code != 401) {
              let tips = "<i class='el-icon-warn-tip'></i>" + oData.data;
              this.$confirm(tips, "提示", {
                confirmButtonText: "好的",
                customClass: "customClass-style",
                iconClass: "",
                dangerouslyUseHTMLString: true,
                confirmButtonClass: "confirm-style",
                showCancelButton: false,
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 添加子权限
    addChild(row) {
      this.dialogVisible = true;
      this.title = "添加子权限";
      this.form = {
        seq: 1,
        status: "0",
      };
      this.valueId = row.id;
      this.valueTitle = row.name;
      this.treeDisabled = true;
    },
    getButtonList(buttonList) {
      let menuId = this.menuId;
      for (
        let i = 0, len = buttonList.length;
        i < len && this.buttonList.length === 0;
        i++
      ) {
        let button = buttonList[i];
        if (button) {
          let children = button.children;
          if (children) {
            children.forEach((child) => {
              this.getChildren(child);
            });
          }
        }
      }
    },
    getChildren(item) {
      let menuId = item.id;
      let children = item.children;
      if (this.menuId === menuId) {
        let otherButton = [];
        for (let i = 0, len = children.length; i < len; i++) {
          let child = children[i];

          if (child) {
            if (child.path === "permission-add") {
              this.addPermission = child;
            } else if (child.path !== "permission-view") {
              otherButton.push(child);
            }
          }
        }
        this.buttonList = otherButton;
      } else {
        if (children) {
          children.forEach((child) => {
            this.getChildren(child);
          });
        }
      }
    },
  },
  mounted() {
    this.setGutterWidth();
    this.query();
    this.buttonList = [];
    this.addPermission = null;
    this.$emit("getMenuList", this.menuId, 1, 0, this.getButtonList);
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },
  created() {
    this.getTableHeight();
  },
  watch: {
    value() {
      this.valueId = this.value;
      this.initHandle();
    },
    dialogVisible: function (nval, oval) {
      this.defaultClearValidate("form");
    },
  },
};
</script>

<style scoped>
.inputClass {
  /* width: 270px !important; */
}
>>>.el-dialog__header {
    /* background-image: url(../../img/common/tableHead.png); */
    /* background-position: 15px 13px;
    background-repeat: no-repeat;
    background-size: 300px 35px; */
    /* padding: 20px 20px 0px 40px ; */
    background: url(../../../assets/img/2dmap/pop_bg.png)  no-repeat;
    background-position: left bottom;
}
.searchClass{
  cursor: pointer;
  cursor: pointer;
  width: 51px;
  height: 16px;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: center;
  color: #00aeff;
  line-height: 16px;
  margin-top: 10px;
  border-left: 1px solid #00aeff;
}
.rowClass {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin: auto 30px;
}
.rowClass .right {
  margin-left: -34px;
}

.adminHomeContainer
  .el-tabs
  .el-tabs__content
  .commonScrollDialog
  .el-dialog
  .el-dialog__body
  .el-form
  .rowClass
  .el-form-item {
  /* width: 270px; */
}

.darkAdminHomeContainer
  .el-tabs
  .el-tabs__content
  .commonScrollDialog
  .el-dialog
  .el-dialog__body
  .el-form
  .rowClass
  .el-form-item {
  /* width: 270px; */
}

.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  /* padding: 0; */
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
  background-color: black !important;
}
ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}
.el-tree-node__label {
  font-weight: normal;
}
.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}
.el-tree {
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/user/permission.vue